// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"715ab9be","87":"d704e2cd","113":"602a4ce9","218":"9475bbb2","465":"6e87dd4f","671":"13311344","944":"c8ac131e","962":"9af8c89a"}[chunkId] + ".chunk.js";
};